import { AxiosResponse } from 'axios';
import axiosClient from './aixosClient';
import { BaseResponse } from 'models/gameModel';

const authApi = {
    login(payload: any): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosClient.post('auth/login-by-encrypted', payload);
    },
};
export default authApi;
